// Ableitungen aus den rohen MatchZy-Summen. Der Server liefert nur Summen
// (total_kills, total_damage, ...) -- alles, was die Rangliste und das
// Detail-Panel zeigen, entsteht hier.

export const initials = (s) =>
  String(s || '')
    .replace(/[^A-Za-z ]/g, '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('') || '?';

export const n1 = (x) => (Math.round((Number(x) || 0) * 100) / 100).toFixed(2);

const div = (a, b, fallback = 0) => (b ? a / b : fallback);

// Die Statistik kennt nur den Ingame-Namen. Klarname, Team und Steam-Avatar
// kommen aus den generierten Teams -- die gibt es erst, wenn ein Admin
// gewuerfelt hat, vorher bleiben die Felder leer.
export const rosterIndex = (teams) => {
  const byName = {};
  (teams || []).forEach((team, i) => {
    (team || []).forEach((user) => {
      byName[user.name] = {
        real: user.nickName || null,
        team: i === 0 ? 'A' : 'B',
        imgUrl: user.imgUrl || null,
        steamID: user.steamID || null,
      };
    });
  });
  return byName;
};

export const enrichPlayers = (players, teams) => {
  const roster = rosterIndex(teams);
  return (players || []).map((p) => {
    const meta = roster[p.name] || {};
    const dmg = Number(p.total_damage) || 0;
    const k = Number(p.total_kills) || 0;
    const a = Number(p.total_assists) || 0;
    const d = Number(p.total_deaths) || 0;
    const util = Number(p.total_utility_damage) || 0;
    const hs = Number(p.total_head_shot_kills) || 0;
    return {
      name: p.name,
      real: meta.real || null,
      team: meta.team || null,
      imgUrl: meta.imgUrl || null,
      steamID: meta.steamID || null,
      dmg,
      k,
      a,
      d,
      util,
      win: Number(p.winrate) || 0,
      matches: Number(p.total_matches) || 0,
      hs,
      entry: Number(p.total_entry_wins) || 0,
      flashed: Number(p.total_enemies_flashed) || 0,
      kd: d ? k / d : k,
      dpk: div(dmg, k),
      surv: d ? dmg / d : dmg,
      apk: div(a, k),
      utilShare: div(util, dmg) * 100,
      hsShare: div(hs, k) * 100,
    };
  });
};

export const averages = (list) => {
  const avg = (f) => (list.length ? list.reduce((s, p) => s + f(p), 0) / list.length : 0);
  return {
    dmg: avg((p) => p.dmg),
    kd: avg((p) => p.kd),
    win: avg((p) => p.win),
    util: avg((p) => p.util),
    dpk: avg((p) => p.dpk),
  };
};

// Ein Balken im Detail-Panel: die Mitte ist der Clan-Schnitt, alles rechts
// davon ist ueberdurchschnittlich.
const bar = (val, ref, label) => {
  const ratio = ref ? val / ref : 1;
  const pct = Math.max(4, Math.min(100, 50 * ratio));
  const good = ratio >= 1;
  const diff = Math.round((ratio - 1) * 100);
  return {
    label,
    delta: (diff >= 0 ? '+' : '') + diff + '% vs avg',
    deltaStyle: { fontVariantNumeric: 'tabular-nums', color: good ? '#3c7a45' : '#a9603c' },
    fill: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      borderRadius: 99,
      width: pct + '%',
      background: good
        ? 'linear-gradient(90deg,#8fc07a,#4f9153)'
        : 'linear-gradient(90deg,#e0c39f,#c58e5f)',
    },
  };
};

export const detailFor = (name, list, avg) => {
  const p = list.find((x) => x.name === name);
  if (!p) return null;
  const byDmg = [...list].sort((a, b) => b.dmg - a.dmg).findIndex((x) => x.name === name) + 1;

  return {
    name: p.name,
    real: p.real,
    imgUrl: p.imgUrl,
    initials: initials(p.name),
    subtitle:
      (p.real ? p.real + ' \u00b7 ' : '') +
      (p.team ? 'Team ' + p.team : 'unassigned') +
      ' \u00b7 rank #' + byDmg + ' by damage',
    tiles: [
      { label: 'K/D', value: n1(p.kd) },
      { label: 'Damage / kill', value: Math.round(p.dpk) },
      { label: 'Damage / death', value: Math.round(p.surv) },
      { label: 'Assists / kill', value: n1(p.apk) },
      { label: 'Utility dmg', value: p.util },
      { label: 'Utility share', value: n1(p.utilShare) + '%' },
      { label: 'Headshot %', value: n1(p.hsShare) + '%' },
      { label: 'Entry wins', value: p.entry },
      { label: 'Enemies flashed', value: p.flashed },
    ],
    bars: [
      bar(p.dmg, avg.dmg, 'Total damage'),
      bar(p.kd, avg.kd, 'K/D'),
      bar(p.win, avg.win, 'Win rate'),
      bar(p.util, avg.util, 'Utility damage'),
      bar(p.dpk, avg.dpk, 'Damage per kill'),
    ],
    notes: [
      p.kd >= 1
        ? 'Trades up: more kills than deaths across the tracked matches.'
        : 'Trades down \u2014 ' + p.d + ' deaths for ' + p.k + ' kills.',
      p.utilShare > 5
        ? 'Heavy utility player: ' + n1(p.utilShare) + '% of output comes from grenades.'
        : 'Almost pure rifle damage, utility barely used.',
      p.win >= avg.win
        ? 'Wins more often than the clan average (' + n1(avg.win) + '%).'
        : 'Below the clan average win rate of ' + n1(avg.win) + '%.',
    ],
  };
};
